import React from 'react';
import { InvoiceTrendChart } from '../Charts/InvoiceTrendChart';

const InvoicesTrend = ({ data = [] }) => (
  <div className="white-wraper extra-mt">
    <h2 className="add-margin">Invoice Trend ({data?.[0]?.year ?? new Date().getFullYear()})</h2>

    <div className="chart-data">
      <ul>
        <li>
          <div className="chart-dot cd5"></div>
          <p>Total</p>
        </li>
        <li>
          <div className="chart-dot cd6"></div>
          <p>Paid</p>
        </li>
        <li>
          <div className="chart-dot cd7"></div>
          <p>Pending</p>
        </li>
      </ul>
    </div>

    <div className="chart-canvas">
      {data.length > 0 ? (
        <InvoiceTrendChart data={data} />
      ) : (
        <div className="text-center text-secondary" style={{ height:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>No data available</div>
      )}
    </div>
  </div>
);

export default InvoicesTrend;
